// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-loop-add-user-loop' )
export class AutomatorBuilderLoopAddUserLoop extends LitElement {
	@property( { type: String } ) accessor size;

	@property( { type: String } ) accessor color = 'secondary';

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				size=${ this.size }
				color=${ this.color }
				@click=${ this.handleAddUserLoop }
			>
				${ strings.userLoop }
			</uo-button>
		`;
	}

	/**
	 * Handles adding a loop too the recipe
	 */
	handleAddUserLoop() {
		// Add a user loop
		UncannyAutomator._core.recipe.item.loop.createLoop( {
			type: 'users'
		} );
	}
}
